const VI_STATUS_WAITING_ADMIN = "Chờ admin xác nhận";
const VI_STATUS_WAITING_STORE = "Chờ cửa hàng nhận";
const VI_STATUS_SENT = "Đã gửi phiếu";

const monthMap = {
  jan: 0,
  january: 0,
  feb: 1,
  february: 1,
  mar: 2,
  march: 2,
  apr: 3,
  april: 3,
  may: 4,
  jun: 5,
  june: 5,
  jul: 6,
  july: 6,
  aug: 7,
  august: 7,
  sep: 8,
  sept: 8,
  september: 8,
  oct: 9,
  october: 9,
  nov: 10,
  november: 10,
  dec: 11,
  december: 11,
};

export const parseDateTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const rawValue = String(value).trim();
  if (!rawValue) return null;

  const normalizedValue = rawValue.split("!")[0].trim();
  const compactDateMatch = normalizedValue.match(
    /^(\d{4})(\d{2})(\d{2})(\d{2})?(\d{2})?(\d{2})?$/
  );

  if (compactDateMatch && ["19", "20"].includes(compactDateMatch[1].slice(0, 2))) {
    const [, year, month, day, hour = "00", minute = "00", second = "00"] =
      compactDateMatch;
    const compactDate = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    );
    return Number.isNaN(compactDate.getTime()) ? null : compactDate;
  }

  const englishMonthDateMatch = normalizedValue.match(
    /^([A-Za-z]{3,9})\s+(\d{1,2})\s+(\d{4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i
  );

  if (englishMonthDateMatch) {
    const [, monthText, day, year, rawHour, minute, second = "00", meridiem] =
      englishMonthDateMatch;
    const month = monthMap[monthText.toLowerCase()];
    if (month !== undefined) {
      let hour = Number(rawHour);
      if (meridiem.toUpperCase() === "PM" && hour !== 12) hour += 12;
      if (meridiem.toUpperCase() === "AM" && hour === 12) hour = 0;

      const englishMonthDate = new Date(
        Number(year),
        month,
        Number(day),
        hour,
        Number(minute),
        Number(second)
      );
      return Number.isNaN(englishMonthDate.getTime())
        ? null
        : englishMonthDate;
    }
  }

  if (/^\d{13}$/.test(normalizedValue)) {
    const timestampDate = new Date(Number(normalizedValue));
    return Number.isNaN(timestampDate.getTime()) ? null : timestampDate;
  }

  if (/^\d{10}$/.test(normalizedValue)) {
    const timestampDate = new Date(Number(normalizedValue) * 1000);
    return Number.isNaN(timestampDate.getTime()) ? null : timestampDate;
  }

  const parsedDate = new Date(normalizedValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const getFirstValidDate = (source, keys) => {
  for (const key of keys) {
    const parsedDate = parseDateTime(source?.[key]);
    if (parsedDate) return parsedDate;
  }

  return null;
};

export const getCreatedAt = (receipt) =>
  getFirstValidDate(receipt, [
    "IDTimeNhap",
    "idTimeNhap",
    "TimeNhap",
    "timeNhap",
    "CreatedAt",
    "createdAt",
    "NgayNhap",
    "ngayNhap",
    "ngay",
  ]);

export const getAdminConfirmedAt = (receipt) =>
  getFirstValidDate(receipt, [
    "TimeXacNhan",
    "timeXacNhan",
    "NgayXacNhan",
    "ngayXacNhan",
    "NgayXacNhanKiemSoat",
    "ngayXacNhanKiemSoat",
    "NgayDuyet",
    "ngayDuyet",
    "ThoiGianXacNhan",
    "thoiGianXacNhan",
    "IDTimeXacNhan",
    "idTimeXacNhan",
    "UpdatedAt",
    "updatedAt",
  ]);

export const getStatusElapsedStartAt = (
  receipt,
  { isTransferReceipt = false, isReturnReceipt = false } = {}
) => {
  if (receipt?.trangThai === VI_STATUS_WAITING_ADMIN) {
    return receipt.createdAt || receipt.ngay;
  }

  if (isTransferReceipt && receipt?.trangThai === VI_STATUS_WAITING_STORE) {
    return receipt.adminConfirmedAt || receipt.createdAt || receipt.ngay;
  }

  if (
    !isTransferReceipt &&
    !isReturnReceipt &&
    receipt?.trangThai === VI_STATUS_SENT
  ) {
    return receipt.createdAt || receipt.ngay;
  }

  return null;
};

export const formatElapsedDuration = (startAt, endAt) => {
  const startDate = parseDateTime(startAt);
  const endDate = parseDateTime(endAt);
  if (!startDate || !endDate) return "";

  const diffMs = Math.max(0, endDate.getTime() - startDate.getTime());
  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) return `${days} ngày ${hours} giờ`;
  if (hours > 0) return `${hours} giờ ${minutes} phút`;
  if (minutes > 0) return `${minutes} phút`;
  return "Vừa xong";
};
